var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotice = function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.31 4.908a1.75 1.75 0 0 1 2.44 1.609v7.966a1.75 1.75 0 0 1-2.44 1.609l-5.422-2.324.852 5.109.145.873h-4.52l-.105-.627-.896-5.376A3.25 3.25 0 0 1 7.5 7.25h4.346zm-4.56 3.587v4.01l5.151 2.208a.25.25 0 0 0 .349-.23V6.517a.25.25 0 0 0-.349-.23zm-1.5.255H7.5a1.75 1.75 0 0 0 0 3.5h3.75zm-1.615 9.5-.75-4.5h1.48l.75 4.5z",
    clipRule: "evenodd"
  })));
};
export default SvgNotice;